'use strict'

const scrollTo = require('scroll-to-element');
const scrollOptions = {
    duration: 800
};

const options = {
    zoom: 7,
    center: new google.maps.LatLng(51.5, 4),
    mapTypeId: google.maps.MapTypeId.ROADMAP
}

const createIcon = location => {
    return {
        ...location, 
        icon: {
            url: location.image,
            size: new google.maps.Size(50, 78),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 78)
          }
    }
}

const getTriggers = location => Object.assign({...location, trigger: document.querySelector(`#${location.id} .marker`)}); 

const triggerListeners = map => location => {

    location.trigger.addEventListener('click', function(e){
        e.preventDefault(); 
        scrollTo('#map',scrollOptions);
        map.panTo(location.position);
        setTimeout(function(){
            map.setZoom(12); 
        },300);
    });
};

const boundsCollector = (bounds,marker) => bounds.extend(marker.position); 

const markerListener = marker => {
    google.maps.event.addListener(marker,'click', function(){
        scrollTo(`#${marker.id}`,scrollOptions)
    });

    return marker;
}

const createMarker = map => location => {
    return new google.maps.Marker({
        position: {
            lat: location.position.lat,
            lng: location.position.lng
        },
        icon: location.icon,
        title: location.name,
        id: location.id,
        map: map
    });
};

const locationMap = (mapElement, locations) => {
    let map = new google.maps.Map(mapElement, options);
    let markerToMap = createMarker(map);
    let markers = locations
        .map(createIcon)
        .map(markerToMap)
        .map(markerListener);

    let triggersCallback = triggerListeners(map);

    let triggers = locations
        .map(getTriggers)
        .forEach(triggersCallback); 
        
    let bounds = markers.reduce(boundsCollector, new google.maps.LatLngBounds()); 
    map.fitBounds(bounds);
}

export default locationMap;